import { configureStore } from '@reduxjs/toolkit'
import { reducer as notificationsReducer } from 'reapop'
import applicationSlice from './questionnaire/questionnaireSlice'

export const store = configureStore({
  reducer: {
    notifications: notificationsReducer(),
    applications: applicationSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch